'use es6';

import BaseCookieLogin from 'Nabisco/BaseCookieLogin';
import { stringify } from 'hub-http/helpers/params';
import Raven from 'Raven';
import { FAILED_LOGIN_PAGES } from '../constants/FailedLoginPages';
const IGNORE_REDIRECT_WRAPPER = new BaseCookieLogin().ignoreRedirectWrapper;
export default {
  create(triggerReset, transitionTo) {
    return ({
      responseJSON
    }) => {
      if (responseJSON) {
        const {
          status
        } = responseJSON;

        if (status in FAILED_LOGIN_PAGES) {
          const nextPath = `${FAILED_LOGIN_PAGES[status]}?${stringify({
            email: responseJSON.errorTokens.email[0]
          })}`;
          transitionTo(nextPath);
        } else {
          triggerReset(status);
        }
      } else {
        triggerReset('LOGIN_UNAVAILABLE');
      }
    };
  },

  createRedirectIgnored(triggerReset, transitionTo) {
    return IGNORE_REDIRECT_WRAPPER(this.create(triggerReset, transitionTo));
  },

  createRavenReporter(message, triggerReset, transitionTo) {
    const handler = this.createRedirectIgnored(triggerReset, transitionTo);
    return response => {
      let errorStatus = response.status;

      if (response.responseJSON) {
        errorStatus = response.responseJSON.status || status;
      }

      Raven.captureMessage(message, {
        extra: {
          response: response.responseText,
          status: response.status
        },
        tags: {
          'error.status': errorStatus
        }
      });
      return handler(response);
    };
  }

};